<template>
    <div class="container-fluid py-2 border" >
        <div class="row">
          <div class="col text-start px-0">
            <p class="py-1 text-white  text-center" style="background:Maroon">รายการรอเรียกเก็บ <span><b>{{seleReqClinic}}</b></span></p>
            <vue-excel-xlsx class="btn btn-outline-secondary btn-sm" title="ดาวน์โหลดไฟล์ Excel" id="btnXLS" ref="btnXLS" @click="alert('TEST Clicked !!')"
            :data="datalists"
            :columns="columnsDtl"
            :filename="'billing_ln_by_cust'"
            :sheetname="'sheetname'"
            >
            <i class="fa fa-download"></i>
            </vue-excel-xlsx>
          </div>
        </div>
        <div class="row">
            <div class="col-sm px-0 py-2">
                <table id="myRepTable2" class="table table-striped table-hover table-bordered table-sm" style="width: 100%;">
                    <thead class="text-dark" style="background:NavajoWhite">
                    <tr>
                        <th style="width:80px;">LN</th>
                        <th style="width:80px;">วันที่เอกสาร</th>
                        <th style="width:80px;">จำนวนเงิน</th>
                    </tr>
                    </thead>
                    <tbody>
                    <!-- <tr v-for="item in datalists" :key="item.itemtestid" v-bind:data-id="item.ItemTestID"  @click="tableChanged(item)"> -->
                    <tr v-for="item in datalists" :key="item.ROID">
                        <td class="text-start">{{ item.RONo }}</td>
                        <td class="text-start">{{item.DocDate}} {{item.DocTime}}</td>
                        <td class="text-end">{{item.NetAmt}}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
// import axios from 'axios'
// import { MyApiClient } from '../myjs/my-api-client.js'
// Bootstrap and jQuery libraries
// import 'bootstrap/dist/css/bootstrap.min.css'
// import 'jquery/dist/jquery.min.js'
// Datatable Modules
// import 'datatables.net-dt/js/dataTables.dataTables'
// import 'datatables.net-dt/css/jquery.dataTables.min.css'
import $ from 'jquery'
// import Swal from 'sweetalert2'
import { inject, ref } from 'vue'

// import JsBarcode from 'jsbarcode/bin/JsBarcode'

import pdfMake from 'pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'
// import htmlToPdfmake from 'html-to-pdfmake'
pdfMake.vfs = pdfFonts.pdfMake.vfs
// // ต้องระบุตามชื่อของ ไฟล์ font
pdfMake.fonts = {
  THSarabunNew: {
    normal: 'THSarabunNew.ttf',
    bold: 'THSarabunNew-Bold.ttf',
    italics: 'THSarabunNew-Italic.ttf',
    bolditalics: 'THSarabunNew-BoldItalic.ttf'
  },
  Roboto: {
    normal: 'Roboto-Regular.ttf',
    bold: 'Roboto-Medium.ttf',
    italics: 'Roboto-Italic.ttf',
    bolditalics: 'Roboto-MediumItalic.ttf'
  }
}

export default {
  setup () {
    var globalCorpID = inject('corpID', ref(-1))
    var globalCorpName = inject('corpName', ref(''))
    var globalBranchID = inject('branchID', ref(-1))
    var globalUserID = inject('userID', ref(-1))
    var globalUserName = inject('userName', ref(''))
    var globalUserOfficialName = inject('userOfficialName', ref(''))
    var globalUserPosition = inject('userPosition', ref(''))
    var globalCorpInfo = inject('corpInfo', {})
    return {
      globalCorpID, globalCorpName, globalBranchID, globalUserID, globalUserName, globalUserOfficialName, globalUserPosition, globalCorpInfo
    }
  },
  name: 'RepLabStatus',
  components: {

  },
  data () {
    return {
      columnsDtl: [
        { label: 'Date in', field: 'DocDate' },
        { label: 'Time in', field: 'DocTime' },
        { label: 'LN', field: 'RONo' },
        { label: 'จำนวนเงิน', field: 'TotalAmt' },
        { label: '%ส่วนลด', field: 'DiscRate' },
        { label: 'ส่วนลด', field: 'DiscAmt' },
        { label: '%Vat', field: 'VatRate' },
        { label: 'Vat', field: 'VatAmt' },
        { label: 'สุทธิ', field: 'NetAmt' },
        { label: 'รหัสคลินิก', field: 'ReqClinicCode' },
        { label: 'ชื่อคลินิก', field: 'ReqClinicName' },
        { label: 'ที่อยู่', field: 'FullAddr' },
        { label: 'โทร', field: 'Tel1' }

      ],
      arrRepeatChk: ['', 'R'],
      arrSex: ['', 'ชาย', 'หญิง'],
      arrDocStatus: ['New', 'Lab', 'Resulted', 'AP'],
      arrPayType: ['เงินสด', 'เครดิต']
    }
  },
  props: ['datalists', 'seleReqClinic'],
  created () {

  },
  mounted () {
    this.$nextTick(() => {
      $('#myRepTable2').DataTable()
    })
  },
  methods: {

  }
}
</script>

<style>

</style>
